export default "__VITE_ASSET__BenXN7c6__"